// extracted by mini-css-extract-plugin
export default {"value":"value_value__K4lLJ"};